import { CatalogDiscount } from '@hiwaldo/sdk/interfaces';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../';
import { useFindDiscountByCodeEffect } from '../../../../server';
import { catalogDataSlice, CatalogDataState } from '../../../redux';

export interface CatalogDiscountDataEffectReturn {
  enact: (code: string) => void;
  clear: () => void;
  loading: boolean;
  success: boolean | undefined;
  error?: string;
}

export interface CatalogDiscountDataEffectProps {
  onComplete?: (discount: CatalogDiscount) => void;
  onError?: (error: string) => void;
}

export const useCatalogDiscountEffect = (
  props?: CatalogDiscountDataEffectProps
): CatalogDiscountDataEffectReturn => {
  const dispatch = useDispatch();

  const { catalogDataState } = useSelector((state: StoreState) => {
    return {
      catalogDataState: state.data.catalog,
    };
  });

  const [success, setSuccess] = useState<boolean | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );

  const findDiscountByCode = useFindDiscountByCodeEffect({
    onComplete: (discount: CatalogDiscount) => {
      const updatedState: CatalogDataState = Object.assign({}, {
        ...catalogDataState,
        discount,
      } as CatalogDataState);

      dispatch(catalogDataSlice.actions.update(updatedState));
      findDiscountByCode.clear();

      setSuccess(true);
      setLoading(false);

      if (props?.onComplete) {
        props.onComplete(discount);
      }
    },
    onError: (error: string) => {
      findDiscountByCode.clear();
      setErrorMessage(error);
      setSuccess(false);
      setLoading(false);

      if (props?.onError) {
        props.onError(error);
      }
    },
  });

  const catalogDiscount = (code: string) => {
    setLoading(true);
    findDiscountByCode.enact(code);
  };

  const clear = () => {
    setErrorMessage(undefined);
    setSuccess(undefined);
    setLoading(false);
  };

  return {
    enact: catalogDiscount,
    clear,
    loading,
    success,
    error: errorMessage,
  };
};
